import { makeStyles } from "@mui/styles";
export const useStyles = makeStyles(({ spacing }) => ({
    ui_typography: {
        marginBottom: ({ gutterBottom, gutterBottomSize }) => gutterBottom
            ? gutterBottomSize === "xs"
                ? spacing(0.5)
                : gutterBottomSize === "sm"
                    ? spacing(1)
                    : gutterBottomSize === "md"
                        ? spacing(2)
                        : gutterBottomSize === "lg"
                            ? spacing(3)
                            : gutterBottomSize === "xl"
                                ? spacing(6)
                                : spacing(0)
            : undefined,
        overflow: ({ ellipsis }) => (ellipsis ? "hidden" : undefined),
        overflowWrap: ({ overflowWrap }) => overflowWrap || undefined,
        textOverflow: ({ ellipsis }) => (ellipsis ? "ellipsis" : undefined),
        whiteSpace: ({ oneline }) => (oneline ? "nowrap" : undefined),
        wordBreak: ({ wordBreak }) => wordBreak || undefined,
    },
}));
//# sourceMappingURL=ui_typography.css.js.map